import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import {
  CustomBorderWrapper, ColumnBetweenWrapper, GenericWrapper,
  FlexBottomWrapper, Mr2, Mr1, Mt2, FullHeightAlignCenterColumn
} from 'wrappers';
import { CustomText, SecondaryTextSmBold, SecondaryText2xlBold, Icon, SecondaryTextSm } from 'atoms';
import internalState from './internalState';
import { UpOrDownArrowSvg, LoadingIndicatorSvg } from 'components/icons';

export const definition = {
  name: 'AnalyticsCard',
  controller: Controller,
  initialProps: ({ title, value, valueLegend, compareValue, compareValueColor, compareText, hasArrow, arrowDirection, isClickable, isLoading }) =>
    ({ title, value, valueLegend, compareValue, compareValueColor, compareText, hasArrow, arrowDirection, isClickable, isLoading }),
  props: internalState,
  elements: [
    {
      wrapper: CustomBorderWrapper,
      name: 'Wrapper',
      isButton: true,
      bindings: ({ isClickable }) => ({ isClickable }),
      displayState: ({ isClickable }) => ({
        border: '1px solid #E3E3E3',
        background: '#FFFFFF',
        borderRadius: '20px',
        height: '129px',
        width: '232px',
        padding: '12px 20px',
        hoverColor: isClickable ? window?.settings?.primary_color ?? '#1DBD6B' : '',
        cursor: isClickable ? 'pointer' : ''
      }),
      elements: [
        {
          wrapper: FullHeightAlignCenterColumn,
          name: 'LoadingWrapper',
          renderIf: ({ isLoading }) => isLoading,
          elements: [
            {
              component: Icon,
              name: 'LoadingSpinner',
              displayValue: ({ }) => LoadingIndicatorSvg({})
            }
          ]
        },
        {
          wrapper: ColumnBetweenWrapper,
          name: 'ColumnWrapper',
          renderIf: ({ isLoading }) => !isLoading,
          displayState: ({ }) => ({ height: '100%' }),
          elements: [
            {
              component: SecondaryTextSmBold,
              name: 'Title',
              displayValue: ({ title }) => title ?? ''
            },
            {
              wrapper: GenericWrapper,
              name: 'BottomWrapper',
              elements: [
                {
                  wrapper: FlexBottomWrapper,
                  name: 'ValueWrapper',
                  elements: [
                    {
                      component: wrap(SecondaryText2xlBold, Mr2),
                      name: 'Value',
                      displayValue: ({ value }) => value ?? ''
                    },
                    {
                      component: wrap(SecondaryTextSm, Mr2),
                      name: 'ValueLegend',
                      renderIf: ({ valueLegend }) => !!valueLegend,
                      displayValue: ({ valueLegend }) => valueLegend
                    },
                    {
                      component: wrap(CustomText, Mr1),
                      name: 'CompareValue',
                      displayState: ({ compareValueColor }) => ({ fontSize: '16px', color: compareValueColor ?? '#1DBD6B' }),
                      displayValue: ({ compareValue }) => compareValue ?? ''
                    },
                    {
                      component: Icon,
                      name: 'Arrow',
                      renderIf: ({ hasArrow }) => hasArrow,
                      displayValue: ({ compareValueColor, arrowDirection }) => UpOrDownArrowSvg({ direction: arrowDirection, color: compareValueColor })
                    }
                  ]
                },
                {
                  component: wrap(CustomText, Mt2),
                  name: 'CompareText',
                  displayState: ({ }) => ({ color: '#9EACB0' }),
                  displayValue: ({ compareText }) => compareText ?? ''
                },
              ]
            }
          ]
        }
      ]
    }
  ]
}

export default ContainerComponent(definition)